(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceResumeDialogController', RaceResumeDialogController);

    RaceResumeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'RaceResume', 'Race', 'RunnerRaceResume'];

    function RaceResumeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, RaceResume, Race, RunnerRaceResume) {
        var vm = this;

        vm.raceResume = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.races = Race.query({filter: 'raceresume-is-null'});
        $q.all([vm.raceResume.$promise, vm.races.$promise]).then(function() {
            if (!vm.raceResume.race || !vm.raceResume.race.id) {
                return $q.reject();
            }
            return Race.get({id : vm.raceResume.race.id}).$promise;
        }).then(function(race) {
            vm.races.push(race);
        });
        vm.runnerraceresumes = RunnerRaceResume.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.raceResume.id !== null) {
                RaceResume.update(vm.raceResume, onSaveSuccess, onSaveError);
            } else {
                RaceResume.save(vm.raceResume, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:raceResumeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.finishDate = false;
        vm.datePickerOpenStatus.startDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
